import { defineComponent as _defineComponent } from 'vue'

import { defaultSubscriptions, Subscription } from '@/foundations/helpers/defaultSubscriptions';
import { defaultRealms, Realm } from '@/foundations/helpers/defaultRealms';

type Props = {
  title: string;
  resource: any;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  props: {
    title: null,
    resource: null
  },
  setup(__props: any) {

const props = __props as {
  title: string;
  resource: any;
}



const filters = [
  {
    source: 'subscriptionTypes',
    label: 'Subscriptions',
    alwaysOn: true,
    type: 'select',
    attributes: {
      multiple: true,
      choices: defaultSubscriptions,
      itemText: (sub: Subscription) => sub.subscription,
    },
  },
  {
    source: 'realm',
    label: 'Market',
    type: 'select',
    attributes: {
      multiple: true,
      choices: defaultRealms,
      itemText: (item: Realm) => item.realm,
      itemValue: (item: Realm) => item.code,
    },
  },
];

const fields = [
  {
    source: 'id',
    link: 'edit',
    sortable: false,
  },
  {
    source: 'category',
    label: 'Category',
    sortable: true,
  },
  {
    source: 'categoryCode',
    label: 'Category Code',
    sortable: true,
  },
  {
    source: 'realms',
    label: 'Market',
    sortable: true,
    type: 'array',
    attributes: {
      color: 'orange',
      column: true,
    },
  },
  {
    source: 'subscriptionTypes',
    label: 'Subscription',
  },
];

return { __sfc: true,props, filters, fields, defaultSubscriptions }
}

})